import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { OrderDirection } from 'store/spot/types'
import { SymbolName } from 'types'
import { RootState } from '../index'
import { TradingViewKLintType } from './reducer'
import { OrderbookData, ShowListType, Tick } from './types'

export function useCurrentChartTab() {
  return useSelector<RootState, TradingViewKLintType>(
    (state) => state.orderbook.currentChartTab,
  )
}
export function useBinanceConnectCount() {
  return useSelector<RootState, number>(
    (state) => state.orderbook.binanceTimeConnect,
  )
}
export function useHideOtherPairs() {
  return useSelector<RootState, boolean>(
    (state) => state.orderbook.hideOtherPairs,
  )
}
export function useResolution() {
  return useSelector<RootState, string>((state) => state.orderbook.resolution)
}

export function useOrderbook() {
  return useSelector<RootState, OrderbookData>(
    (state) => state.orderbook.orderbook,
  )
}
export function useOrderbookPrecision() {
  return useSelector<RootState, string>((state) => state.orderbook.precision)
}
export function useShowListType() {
  return useSelector<RootState, ShowListType>(
    (state) => state.orderbook.showListType,
  )
}

export function useBestAvailablePrice(): Record<OrderDirection, string> {
  const orderbook = useOrderbook()

  return useMemo(() => {
    const { buyOrders = [], sellOrders = [] } = orderbook
    return {
      LONG: buyOrders[0]?.price ?? '0',
      SHORT: sellOrders[0]?.price ?? '0',
    }
  }, [orderbook])
}

export function useTickList(symbolName: SymbolName) {
  return useSelector<RootState, Tick[]>(
    (state) => state.orderbook.tickList[symbolName] ?? [],
  )
}

export function useChartType() {
  return useSelector<RootState, number>((state) => state.orderbook.chartType)
}

export function useFavoriteResolution() {
  return useSelector<RootState, Array<string>>(
    (state) => state.orderbook.favoriteResolution,
  )
}
